import { render, staticRenderFns } from "./ProjectStatusList.vue?vue&type=template&id=2ccc95de&scoped=true"
import script from "./ProjectStatusList.vue?vue&type=script&lang=js"
export * from "./ProjectStatusList.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatusList.vue?vue&type=style&index=0&id=2ccc95de&prod&lang=scss&scoped=true"
import style1 from "./ProjectStatusList.vue?vue&type=style&index=1&id=2ccc95de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc95de",
  null
  
)

export default component.exports